<template>
  <div class="gift-item">
    <div class="g-img">
      <img class="img-icon" v-lazy="item.smallPic || item.thumbnailPic" alt="" />
      <div
        :class="[
          'g-type',
          {
            'type-member-1': item.giftType == 42 && item.vipGiftLevel == 1,
            'type-member-2': item.giftType == 42 && item.vipGiftLevel == 2,
            'type-member-3': item.giftType == 42 && item.vipGiftLevel == 3,
            'type-member-4': item.giftType == 42 && item.vipGiftLevel == 4,
            'type-hour': item.giftType == 43 || item.giftType == 45
          }
        ]"
        v-if="showTypeIcon && item.giftType"
      >
        <template v-if="item.giftType == 42">
          <p v-if="item.vipGiftLevel == 1">会员专享</p>
          <p v-if="item.vipGiftLevel == 2">白银专享</p>
          <p v-if="item.vipGiftLevel == 3">黄金专享</p>
          <p v-if="item.vipGiftLevel == 4">钻石专享</p>
        </template>
        <p v-if="item.giftType == 43">整点加赠</p>
        <p v-if="item.giftType == 45">已购权益</p>
      </div>
    </div>
    <div
      class="g-info"
      v-track="[
        {
          act: 'click',
          params: {
            cfrom: '160|002|01|077',
            event_id: '160|002|01|077',
            page_name: customParams.page_name,
            sku_id: skuId,
            gift_type: item.giftFlag,
            gift_content: contentChange(item),
            position: positionKey + 1,
            isno_choose: item.optionalGiftId ? 1 : 0
          }
        },
        {
          act: 'show',
          params: {
            cfrom: '160|003|02|077',
            event_id: '160|003|02|077',
            page_name: customParams.page_name,
            sku_id: skuId,
            gift_type: item.giftFlag,
            gift_content: contentChange(item),
            position: positionKey + 1,
            isno_choose: isOptional ? 1 : 0
          }
        }
      ]"
    >
      <div class="g-title">{{ item.name }}</div>
      <!-- 实物展示规格及价格，优惠券不展示 -->
      <div class="g-tips" v-if="showTypeIcon && item.shortDesc">
        <div class="g-tips-content" v-if="item.giftType == 43">
          <i></i>
          <div class="g-desc red">{{ item.shortDesc }}</div>
        </div>
        <div class="g-desc" v-else>{{ item.shortDesc }}</div>
      </div>
      <div class="g-price" v-if="item.color || item.marketPrice">
        <span class="g-color" v-if="item.color">{{ item.color }}</span>
        <template v-if="item.marketPrice > 0">
          <dfn>&yen;</dfn>
          <span>{{ item.marketPrice }}</span>
        </template>
      </div>
    </div>
    <div class="g-num" v-if="item.num">X{{ item.num }}</div>
  </div>
</template>

<script>
export default {
  name: 'giftItem',
  props: {
    item: Object,
    showTypeIcon: {
      type: Boolean,
      default: false
    },
    positionKey: Number,
    isOptional: Boolean,
    skuId: [String, Number],
    customParams: Object
  },
  data() {
    return {
      //
    }
  },
  methods: {
    contentChange(item) {
      let content
      // giftType 赠品活动类型：41：常规赠品 42：会员加赠 43：整点加赠 44：仅赠券
      // gift_content##内容id(1:整点加赠;2:常规赠品;3:会员加赠)
      if (item.giftType == 41) {
        content = 2
      } else if (item.giftType == 42) {
        content = 3
      } else if (item.giftType == 43) {
        content = 1
      }
      return content
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
